<template>
    <div class="main noTakeaway">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="broadcast"/>
                <Article :article="comment"/>
                <Article :article="review"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ymx',
    // meta配置
    metaInfo: {
        title: '【专题】' + '亚马逊“封店潮”致超千亿损失 跨境电商卖家将何去何从？',
        meta: [
            {
                name: 'keywords',
                content: '亚马逊'
            },
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/ymx/banner.jpg'),
                title: [
                    '亚马逊“封店潮”致超千亿损失 跨境电商卖家将何去何从？',
                ],
            },

            // 置顶头条
            headlines: [
                {
                    title: '【电商快评】亚马逊“封店潮”致超千亿损失 跨境电商卖家将何去何从？',
                    url: '/detail--6599682.html'
                },
            ],

            // 滚动播报
            broadcast: {
                title: {
                    topic: '滚动播报',
                },
                params: {
                    p: 1,
                    n: 5,
                    terms: '亚马逊'
                },
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                params: {
                    p: 1,
                    name: '',
                    title: '亚马逊'
                },
            }
        }
    },
}
</script>

<style>

</style>
